export default __webpack_public_path__ + "static/media/report.6af8efd5.png";